import { onComponentRef } from '@utils/dom';
import { FunctionComponent, useRef } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { StylePortalProps } from '../types';

const Parent = styled.div``;

const ParentStyle = createGlobalStyle<{
  styled: StylePortalProps['styled'];
}>`

  ${({ styled }) => css`
    ${Parent} {
      ${styled}
    }
  `}
`;

const StylePortal: FunctionComponent<StylePortalProps> = ({
  children,
  parentCssClass,
  styled,
}) => {
  const componentRef = useRef<HTMLElement>();

  function onRef(ref: HTMLElement | null) {
    return onComponentRef({
      componentRef,
      parentCssClass,
      ref,
    });
  }

  return (
    <>
      <ParentStyle styled={styled} />
      <Parent ref={onRef}>{children}</Parent>
    </>
  );
};

export default StylePortal;
